import styles from "./index.module.css";
export default function AgenzHelperCard({
  icon,
  borderClassName,
  title,
  subtitle,
  buttonText,
  buttonAction,
  buttonLink,
  alternateComponent,
  mapVsList,
}: {
  icon: any;
  borderClassName: string;
  title: string;
  subtitle: string;
  buttonText: string;
  buttonAction: any;
  buttonLink?: string;
  alternateComponent?: any;
  mapVsList: string;
}) {
  return (
    <>
      <div
        className={`${styles.activerLalerte} ${styles[borderClassName]}`}
        style={mapVsList == "MAP" ? {
          flexDirection: "column",
          justifyContent: "center",
        } : {}}
      >
        {alternateComponent ? (
          <>{alternateComponent}</>
        ) : (
          <>
          <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            gap: "8px"
          }}>
            <div className={styles.activerLalerteWrapper}>
              <b
                className={styles.activerLalerte1}
                    style={mapVsList == "MAP" ? {
                      textAlign: "center"
                    } : {}}
              >{title}</b>
            </div>
            <div className={styles.pourCetteRecherchePourReceWrapper}>
              <div
                className={styles.activerLalerte1}
                    style={mapVsList == "MAP" ? {
                      textAlign: "center"
                    } : {}}
              >{subtitle}</div>
            </div>
          </div>
            <div
              data-tracking="click"
              data-value=""
              className={`${styles.activerLalerte2} ${
                borderClassName == "green" ? styles.btn_green : ""
              }`}
              onClick={() => {
                buttonAction();
              }}
            >
              {icon}
              {buttonText}
            </div>
          </>
        )}
      </div>
    </>
  );
}
